export const StickyNavigationSpacer = () => {
  return (
    <div className="hidden group-[.sticky]:block">
      <div className="h-xxs max-h-xxs min-h-xxs w-full" />
      <div className="m:block hidden h-full m:h-clickable-minimum m:max-h-clickable-minimum w-full" />
      <div className=" h-clickable l:h-[72px] s:h-[66px] w-full" />
      <div className="mt-xxs box-content l:block hidden h-clickable w-full pt-xxs pb-xs" />
    </div>
  );
};
